module.exports = "/images/alert.svg?b0a8b9fb150183e7732e4f05b504ac16";